import LightSplashScreenSVG from "./vectors/lightBG.svg";
import DarkSplashScreenBg from "./images/dark.jpg";
import Logo from "./vectors/logo.svg";
import Exit from "./vectors/exit.svg";
import GoBack from "./vectors/back.svg";
import KeyIcon from "./vectors/key.svg";
import HomeIcon from "./vectors/home.svg";
import Avatar from "./images/avatar.jpg";
import BellIcon from "./vectors/bell.svg";
import InboxIcon from "./vectors/inbox.svg";
import FeedIcon from "./vectors/feed.svg";
import CityVector from "./vectors/city.svg";
import CopyVector from "./vectors/copy.svg";
import SkylineImg from "./images/skyline.png";
import NoResultsVector from "./vectors/noResult.svg";
import DissapointmentVector from "./vectors/disappointment.svg";
import SendVector from "./vectors/send.svg";
import AddReservation from "./vectors/add-reservation.svg";
import ReplyVector from "./vectors/reply.svg";
import MessagesVector from "./vectors/messages.svg";
import SuitcaseVector from "./vectors/suitcase.svg";
import SuccessVector from "./vectors/success.svg";
import NoPhotoAvailableVector from "./vectors/no-photo.svg";
import ReservationsNavIcon from "./vectors/reservationsIcon.svg";
import ArrowRightIcon from "./vectors/arrow-right.svg";
import CloseIcon from "./vectors/close.svg";
import SearchIcon from "./vectors/search-icon.svg";
import GuestIcon from "./vectors/guest.svg";
import BedIcon from "./vectors/bed.svg";
import BathIcon from "./vectors/bath.svg";
import imagePlaceholderDark from "./vectors/image-placeholder-dark.svg";
import imagePlaceholderWhite from "./vectors/image-placeholder-white.svg";
import plusIcon from "./vectors/plus.svg";
import minusIcon from "./vectors/minus.svg";
import happyWoman from "./vectors/happy.svg";
import logoutIcon from "./vectors/logout.svg";
import userIcon from "./vectors/user.svg";
import mapIcon from "./vectors/map.svg";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  Logo,
  DarkSplashScreenBg,
  LightSplashScreenSVG,
  Exit,
  GoBack,
  KeyIcon,
  HomeIcon,
  Avatar,
  BellIcon,
  InboxIcon,
  FeedIcon,
  CityVector,
  SkylineImg,
  CopyVector,
  NoResultsVector,
  DissapointmentVector,
  SendVector,
  AddReservation,
  ReplyVector,
  MessagesVector,
  SuitcaseVector,
  SuccessVector,
  NoPhotoAvailableVector,
  ReservationsNavIcon,
  ArrowRightIcon,
  CloseIcon,
  SearchIcon,
  GuestIcon,
  BedIcon,
  BathIcon,
  imagePlaceholderDark,
  imagePlaceholderWhite,
  plusIcon,
  minusIcon,
  happyWoman,
  logoutIcon,
  userIcon,
  mapIcon,
};
